"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _templateObject = _taggedTemplateLiteral(["\n  left: ", ";\n  position: absolute;\n  top: ", ";\n  transform: ", ";\n"], ["\n  left: ", ";\n  position: absolute;\n  top: ", ";\n  transform: ", ";\n"]);

var _styledComponents = require("styled-components");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _propTypes = require("./propTypes");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _taggedTemplateLiteral(strings, raw) {
  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

var Absolute = _styledComponents2.default.div(_templateObject, function (props) {
  return props.horizontal || props.both ? '50%' : undefined;
}, function (props) {
  return props.vertical || props.both ? '50%' : undefined;
}, function (props) {
  return "translate(" + (props.horizontal || props.both ? '-50%' : 0) + ", " + (props.vertical || props.both ? '-50%' : 0) + ")";
});

Absolute.defaultProps = _propTypes.absoluteDefaultProps;
Absolute.propTypeabsolutePropTypess = _propTypes.absolutePropTypes;
exports.default = Absolute;